<template>
    <router-view style="height: 100%"></router-view>
</template>

<script>
export default {
  name: "localeRouterView",
  props : ['lang'],
  computed : {
    token() {
      return this.$i18n.availableLocales
    }
  },
  beforeMount() {
    this.$store.state.routeLang = this.lang
    if (this.lang){
      if ( !this.$i18n.availableLocales.includes(this.lang) ) {
        return
      }
      this.$i18n.locale = this.lang
    }
  }
}
</script>

<style scoped>

</style>